import { useEffect, useState } from 'react';

/** Below this width the sidebar is an overlay drawer and the main area spans the
 *  viewport (Layout.css). Shared so anything pinned to the main area agrees. */
export const NARROW_QUERY = '(max-width: 900px)';

/** jsdom and old browsers have no matchMedia: treat them as wide. */
const hasMatchMedia = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

export function useIsNarrow() {
  return useMediaMatch(NARROW_QUERY);
}

/** Whether a media query matches now, following changes. */
export function useMediaMatch(query: string) {
  const [match, setMatch] = useState(() => hasMatchMedia() && window.matchMedia(query).matches);
  useEffect(() => {
    if (!hasMatchMedia()) return;
    const mq = window.matchMedia(query);
    setMatch(mq.matches);
    const onChange = () => setMatch(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);
  return match;
}
